import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalizedPath } from "@/i18n/useLocalizedPath";

export const LandingFooter = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("landing");
  // Own namespace, loaded lazily and WITHOUT suspense: the partner copy must
  // not block the landing page's first paint just to label one footer link.
  // The defaultValue renders immediately and is replaced once the file lands.
  const { t: tPartners } = useTranslation("partners", { useSuspense: false });
  const lp = useLocalizedPath();
  return (
    <footer className="border-t border-border py-10 px-4">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <img
            src="/workloop-logo.png"
            alt="Workloop"
            width="24"
            height="24"
            loading="lazy"
            decoding="async"
            className="h-6 w-6"
          />
          <span className="font-display font-semibold text-foreground">Workloop</span>
          <span className="ml-2 text-xs text-muted-foreground/70">
            {t("footer.copyright")} {new Date().getFullYear()}
          </span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <button onClick={() => navigate(lp("/blog"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
            {t("footer.blog")}
          </button>
          <button onClick={() => navigate(lp("/privacy"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
            {t("footer.privacy")}
          </button>
          <button onClick={() => navigate(lp("/terms"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
            {t("footer.terms")}
          </button>
          <button onClick={() => navigate(lp("/disclaimers"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
            {t("footer.disclaimers")}
          </button>
          <a href="mailto:support@workloop.us" className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
            {t("footer.contact")}
          </a>
          <a href="tel:+13055376435" className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
            (305) 537-6435
          </a>
        </div>
      </div>
      <div className="container mx-auto mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs">
        <button onClick={() => navigate(lp("/hvac-scheduling-software"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
          {t("footer.hvac")}
        </button>
        <button onClick={() => navigate(lp("/plumbing-software"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
          {t("footer.plumbing")}
        </button>
        <button onClick={() => navigate(lp("/electrical-contractor-software"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
          {t("footer.electrical")}
        </button>
        <button onClick={() => navigate(lp("/customer-app"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
          {t("footer.customerApp")}
        </button>
        {/* /partners had exactly one entry point on the whole internet: the QR
            on a printed flyer. Nothing on workloop.us linked to it. */}
        <button onClick={() => navigate(lp("/partners"))} className="inline-flex min-h-11 items-center px-1 transition-colors hover:text-foreground sm:min-h-0 sm:px-0">
          {tPartners("badge", { defaultValue: "Partner Program" })}
        </button>
      </div>
      <div className="container mx-auto mt-4 text-center text-xs text-muted-foreground/70">
        {t("footer.entity")}
      </div>
    </footer>
  );
};
